'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Autocomplete: ()=>Autocomplete_Autocomplete
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
const external_downshift_namespaceObject = require("downshift");
const AutocompleteListItem_cjs_namespaceObject = require("./AutocompleteListItem/AutocompleteListItem.cjs");
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_InputText_index_cjs_namespaceObject = require("../InputText/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const external_ScrollArea_index_cjs_namespaceObject = require("../ScrollArea/index.cjs");
function getIconName(itemLocationType) {
    if ('AIRPORT' === itemLocationType) return 'flight_takeoff';
    if ('POI' === itemLocationType) return 'location_on';
    return 'location_city';
}
const Autocomplete_Autocomplete = function({ autocompleteData, handleInputChange, handleSelectItem, handleOnMenuOpen, initialSelectedItem, name, helperText, iconName = 'search', label = 'Where to?', className, errorMessage, inputRef }) {
    const [items, setItems] = (0, external_react_namespaceObject.useState)([
        ...autocompleteData
    ]);
    const [selectedItem, setSelectedItem] = (0, external_react_namespaceObject.useState)(initialSelectedItem ?? null);
    const [highlightedIndexWithKeyArrow, setHighlightedIndexWithKeyArrow] = (0, external_react_namespaceObject.useState)(-1);
    const wrapperClassName = (0, cn_cjs_namespaceObject.cn)('relative flex flex-col gap-1', className);
    (0, external_react_namespaceObject.useEffect)(()=>{
        setItems([
            ...autocompleteData
        ]);
    }, [
        autocompleteData
    ]);
    const { isOpen, getMenuProps, getInputProps, highlightedIndex, getItemProps } = (0, external_downshift_namespaceObject.useCombobox)({
        initialSelectedItem: initialSelectedItem ?? null,
        initialInputValue: initialSelectedItem?.itemName ?? '',
        onInputValueChange ({ inputValue }) {
            if ('' === inputValue) setSelectedItem(null);
            handleInputChange(inputValue);
        },
        onSelectedItemChange ({ selectedItem }) {
            if (selectedItem && handleSelectItem) handleSelectItem(selectedItem);
            setSelectedItem(selectedItem);
        },
        onHighlightedIndexChange: (event)=>{
            '__input_keydown_arrow_down__' === event.type || '__input_keydown_arrow_up__' === event.type ? setHighlightedIndexWithKeyArrow(event.highlightedIndex) : setHighlightedIndexWithKeyArrow(-1);
        },
        onIsOpenChange: ()=>{
            if (!isOpen && handleOnMenuOpen) handleOnMenuOpen();
        },
        items,
        itemToString (item) {
            return item ? item.itemName : '';
        }
    });
    const inputProps = getInputProps({
        id: 'base-ui-:r2:',
        ref: inputRef
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: wrapperClassName,
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_InputText_index_cjs_namespaceObject.InputText, {
                iconLeft: iconName ?? void 0,
                isInset: true,
                label: label,
                "data-testid": "autocomplete-input",
                name: name,
                errorMessage: errorMessage,
                helperText: helperText,
                hasExternalError: Boolean(errorMessage),
                ...inputProps
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("ul", {
                className: `flex flex-col gap-1 shadow-md ${!(isOpen && items.length) && 'hidden'} z-100 bg-neutral-1 absolute top-[52px] h-[300px] w-full rounded-xl`,
                ...getMenuProps(),
                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_ScrollArea_index_cjs_namespaceObject.ScrollArea, {
                    className: "h-full",
                    children: isOpen && items.length > 0 && items.map((item, index)=>void 0 === item.isGroupHeader ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(AutocompleteListItem_cjs_namespaceObject.AutocompleteListItem, {
                            firstLine: item.displayLine1 ?? item.itemName,
                            secondLine: item.displayLine2 ?? void 0,
                            leftNode: item.type && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                                palette: "primary",
                                shade: "10",
                                iconName: getIconName(item.type),
                                size: "24"
                            }),
                            isHighlighted: highlightedIndex === index,
                            isHighlightedIndexWithKeyArrow: highlightedIndexWithKeyArrow === index,
                            isSelected: selectedItem?.itemName === item.itemName,
                            ...getItemProps({
                                item,
                                index
                            })
                        }, `${item.itemName}`) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "h-8 p-1 pt-3",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                textStyle: "body3",
                                color: "primary-13",
                                children: item.itemName
                            })
                        }, `${item.itemName}`))
                })
            })
        ]
    });
};
exports.Autocomplete = __webpack_exports__.Autocomplete;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Autocomplete"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
